export type Category = {
  slug: string;
  name: string;
  short: string;
  icon: string;
  hint: string;
};

/** Категории сайта бизнес-предложений. Плоский список — без вложенности. */
export const CATEGORIES: Category[] = [
  { slug: "gotoviy-biznes", name: "Готовый бизнес", short: "Готовый бизнес", icon: "🏪", hint: "Продажа действующего бизнеса" },
  { slug: "kuplyu-biznes", name: "Куплю бизнес", short: "Куплю бизнес", icon: "🔍", hint: "Ищу бизнес для покупки" },
  { slug: "ishchu-investora", name: "Ищу инвестора", short: "Ищу инвестора", icon: "🤝", hint: "Нужны вложения в проект" },
  { slug: "vlozhus-v-biznes", name: "Вложусь в бизнес", short: "Вложусь в бизнес", icon: "💰", hint: "Инвестор ищет проекты" },
  { slug: "ishchu-partnera", name: "Ищу партнёра", short: "Ищу партнёра", icon: "👥", hint: "Партнёр или сооснователь" },
  { slug: "startapy", name: "Стартапы", short: "Стартапы", icon: "🚀", hint: "Проекты на старте" },
  { slug: "internet-biznes", name: "Интернет-бизнес", short: "Интернет-бизнес", icon: "🌐", hint: "Сайты, магазины, каналы" },
  { slug: "franshizy", name: "Франшизы", short: "Франшизы", icon: "🏷️", hint: "Франшизы и франчайзи" },
  { slug: "sposoby-zarabotka", name: "Способы заработка", short: "Способы заработка", icon: "📈", hint: "Идеи и схемы заработка" },
  { slug: "obuchenie", name: "Обучение и курсы", short: "Обучение и курсы", icon: "🎓", hint: "Бизнес-обучение, наставники" },
  { slug: "oborudovanie-pomeshcheniya", name: "Оборудование и помещения", short: "Оборудование", icon: "🏭", hint: "Активы, площади под бизнес" },
  { slug: "uslugi-dlya-biznesa", name: "Услуги для бизнеса", short: "Услуги", icon: "🧰", hint: "Бухгалтерия, юристы, реклама" },
];

export const CITIES = [
  { slug: "moskva", name: "Москва" },
  { slug: "sankt-peterburg", name: "Санкт-Петербург" },
  { slug: "novosibirsk", name: "Новосибирск" },
  { slug: "ekaterinburg", name: "Екатеринбург" },
  { slug: "kazan", name: "Казань" },
  { slug: "nizhniy-novgorod", name: "Нижний Новгород" },
  { slug: "krasnodar", name: "Краснодар" },
  { slug: "samara", name: "Самара" },
  { slug: "rostov-na-donu", name: "Ростов-на-Дону" },
  { slug: "ufa", name: "Уфа" },
  { slug: "chelyabinsk", name: "Челябинск" },
  { slug: "perm", name: "Пермь" },
  { slug: "voronezh", name: "Воронеж" },
  { slug: "volgograd", name: "Волгоград" },
  { slug: "krasnoyarsk", name: "Красноярск" },
  { slug: "tyumen", name: "Тюмень" },
  { slug: "sochi", name: "Сочи" },
  { slug: "bryansk", name: "Брянск" },
];

export type Listing = {
  id: number;
  title: string;
  price: number | null;
  priceNote?: string;
  category: string;
  city: string;
  description: string;
  createdAt: string;
  tone: number;
};

/** Временные демо-объявления. Заменятся на выборку из Postgres. */
export const LISTINGS: Listing[] = [
  { id: 1001, title: "Кофейня в центре, работает 3 года", price: 850000, category: "gotoviy-biznes", city: "moskva", description: "Полностью оборудованная кофейня у метро. Прибыль 120 000 ₽/мес, окупаемость 7 месяцев. Оборудование и персонал остаются.", createdAt: "сегодня, 14:20", tone: 0 },
  { id: 1002, title: "Куплю действующий автосервис", price: null, priceNote: "до 3 000 000 ₽", category: "kuplyu-biznes", city: "krasnodar", description: "Рассмотрю автосервис или шиномонтаж с оборудованием и базой клиентов. Оплата сразу, без рассрочки.", createdAt: "сегодня, 12:05", tone: 1 },
  { id: 1003, title: "Ищу инвестора в пекарню, доля 40%", price: 2000000, category: "ishchu-investora", city: "kazan", description: "Открываем вторую точку, помещение найдено. Нужны вложения на оборудование и запуск, возврат за 18 месяцев.", createdAt: "вчера, 19:40", tone: 2 },
  { id: 1004, title: "Магазин на Wildberries, оборот 1,8 млн", price: 1200000, category: "internet-biznes", city: "sankt-peterburg", description: "Карточки в топе, поставщик проверенный, остатки товара включены. Передаю аккаунт и связи с поставщиками.", createdAt: "вчера, 17:12", tone: 3 },
  { id: 1005, title: "Вложу 5 млн в работающий бизнес", price: null, priceNote: "Инвестор", category: "vlozhus-v-biznes", city: "moskva", description: "Интересует общепит, розница и производство с прибылью от 200 000 ₽/мес. Рассмотрю долю или полную покупку.", createdAt: "вчера, 15:30", tone: 4 },
  { id: 1006, title: "Ищу партнёра в студию маникюра", price: null, priceNote: "Партнёрство", category: "ishchu-partnera", city: "ekaterinburg", description: "Есть помещение и мастера, нужен партнёр по маркетингу и управлению. Доля обсуждается.", createdAt: "вчера, 11:00", tone: 5 },
  { id: 1007, title: "Шиномонтаж у трассы, 2 бокса", price: 1450000, category: "gotoviy-biznes", city: "bryansk", description: "Проходное место, круглосуточный режим. Всё оборудование в собственности, аренда земли на 5 лет.", createdAt: "2 дня назад", tone: 6 },
  { id: 1008, title: "Франшиза пункта выдачи заказов", price: 390000, category: "franshizy", city: "samara", description: "Паушальный взнос входит в цену. Помогаем с подбором помещения и запуском за 3 недели.", createdAt: "2 дня назад", tone: 7 },
  { id: 1009, title: "Telegram-канал 45 000 подписчиков", price: 680000, category: "internet-biznes", city: "moskva", description: "Тематика — бизнес и финансы. Доход от рекламы 90 000 ₽/мес, статистика открыта при переписке.", createdAt: "3 дня назад", tone: 8 },
  { id: 1010, title: "Стартап: сервис доставки для кафе", price: null, priceNote: "Ищу команду", category: "startapy", city: "novosibirsk", description: "MVP готов, первые 12 заведений подключены. Нужен технический партнёр и инвестиции на масштабирование.", createdAt: "3 дня назад", tone: 9 },
  { id: 1011, title: "Наставничество: запуск бизнеса с нуля", price: 35000, category: "obuchenie", city: "sankt-peterburg", description: "Практик с 12-летним опытом. Разбираем нишу, финмодель и первые продажи за 6 недель.", createdAt: "4 дня назад", tone: 10 },
  { id: 1012, title: "Оборудование кафе после закрытия", price: 420000, category: "oborudovanie-pomeshcheniya", city: "rostov-na-donu", description: "Кофемашина, холодильные витрины, мебель. Всё рабочее, продаю одним лотом, возможен самовывоз.", createdAt: "4 дня назад", tone: 11 },
];

export const priceFormat = (v: number) =>
  new Intl.NumberFormat("ru-RU").format(v) + " ₽";

export const categoryBySlug = (slug?: string) =>
  CATEGORIES.find((c) => c.slug === slug);

export const cityBySlug = (slug?: string) =>
  CITIES.find((c) => c.slug === slug);
